export default "__VITE_ASSET__DF2L25ys__"